const messages = {
    de: {
        equip: {
            language: "Sprache",
            language_german: "deutsch",
            language_english: "englisch",
            name: "Name",
            description: "Beschreibung",
            isMassProduct: "ist Mengenartikel",
            isContainer: "ist Container",
            quantity: "Anzahl",
            openQuantity: "Offene Menge",
            lostQuantity: "Verloren",
            defectQuantity: "Defekt",
            delayedQuantity: "Verspätet",
            status: "Status",
            availability: "Verfügbarkeit",
            inStock: "Lagermenge",
            actualQuantity: "verfügbare Menge",
            minimumQuantity: "Mindestbestand",
            productStockAlerts: "Bestandsalarme",
            suggestedOrderQuantity: "Bestellvorschlag",
            alertDate: "Alert-Datum",
            firstActualQuantity: "Erste verfügbare Menge",
            lowestActualQuantity: "Tagestief",
            lastActualQuantity: "Letzte verfügbare Menge",
            isRelevant: "Relevant",
            hasRelevantAlerts: "Offen",
            onlyOpenStockAlerts: "Nur offene Unterbestände",
            daysBelowThreshold: "Tage unter Schwelle",
            relevantAlertDays: "Offene Alert-Tage",
            highestMissingQuantity: "Größter Fehlbestand",
            currentMissingQuantity: "Aktueller Fehlbestand",
            movementMarkup: "Bewegungsaufschlag",
            movementMarkupPercentage: "Bewegungsaufschlag (%)",
            movementMarkupQuantity: "Bewegungsaufschlag",
            firstAlertDate: "Erster Alert",
            lastAlertDate: "Letzter Alert",
            fromAlertDate: "Alerts ab",
            toAlertDate: "Alerts bis",
            resolvedAt: "Erledigt am",
            resolvedByArrival: "Erledigt durch Wareneingang",
            rentals: "Ausleihen",
            overdueRentals: "Überfällige Ausleihen",
            overdue: "Überfällig",
            landingPage: "Landingpage",
            openLandingPage: "Landingpage öffnen",
            maintenance: "Wartung",
            maintenanceAlarm: "Wartungsalarm",
            maintenanceName: "Wartungsname",
            maintenanceRentalDays: "Wartung nach Leihtagen",
            maintenanceRentalDaysCount: "Gezählte Leihtage",
            maintenanceOverdueDays: "Überfällige Wartungstage",
            maintenanceMessage: "Wartungshinweis",
            maintenanceCreatedBy: "Wartungsalarm erstellt von",
            maintenanceStartedAt: "Wartungszählung gestartet am",
            maintenanceLastCompletedAt: "Letzte Wartung erledigt am",
            completeMaintenance: "Wartung erledigen",
            nextMaintenanceRentalDays: "Nächste Wartung nach Leihtagen",
            maintenanceRequired: "Wartung erforderlich",
            maintenanceDone: "Wartung wurde erledigt",
            rentWithoutMaintenance: "Trotzdem ausleihen",
            skuInspections: "VDE/UVV Prüfungen",
            inspectionRequired: "Prüfung erforderlich",
            inspectionType: "Prüfart",
            inspectionResult: "Prüfergebnis",
            recordInspection: "Prüfung eintragen",
            nextInspectionDueAt: "Nächster Prüftermin",
            continueWithoutInspection: "Ohne Prüftermin fortfahren",
            vdeInspectionIntervalMonths: "VDE Prüfintervall (Monate)",
            uvvInspectionIntervalMonths: "UVV Prüfintervall (Monate)",
            noInspectionInterval: "Leer lassen für kein Prüfintervall",
            lastVdeInspectionAt: "Letzte VDE Prüfung",
            lastUvvInspectionAt: "Letzte UVV Prüfung",
            skuInspectionType_vde: "VDE",
            skuInspectionType_uvv: "UVV",
            skuInspectionResult_passed: "Bestanden",
            skuInspectionResult_failed: "Nicht bestanden",
            yes: "Ja",
            no: "Nein",
            repairOrder: "Reparaturauftrag",
            repairOrders: "Reparaturaufträge",
            category: "Kategorie",
            categories: "Kategorien",
            manufacturer: "Hersteller",
            manufacturers: "Hersteller",
            repairShop: "Reparaturwerkstatt",
            repairShops: "Reparaturwerkstätten",
            supplier: "Lieferant",
            suppliers: "Lieferanten",
            storageLocation: "Lagerort",
            storageLocations: "Lagerorte",
            users: "Benutzer",
            product: "Produkt",
            products: "Produkte",
            type: "Typ",
            tags: "Tags",
            originCountry: "Ursprungsland",
            deliveryDate: "Lieferdatum",
            purchasePrice: "Einkaufspreis (EUR)",
            purchasePricePerItem: "Einkaufspreis pro Stück (EUR)",
            currentPrice: "Zeitwert (EUR)",
            carnetPrice: "Carnet Preis",
            weight: "Gewicht (kg)",
            weightPerItem: "Gewicht pro Stück (kg)",
            sku: "SKU",
            skus: "SKUs",
            skuRequired: "SKU erforderlich",
            labelNumber: "Label-Nummer",
            sku_status_active: "aktiv",
            sku_status_deactivated: "deaktiviert",
            sku_status_eliminated: "ausgesondert",
            sku_availability_available: "verfügbar",
            sku_availability_rented_out: "verliehen",
            sku_availability_defect: "defekt",
            sku_availability_lost: "verlust",
            sku_availability_in_repair: "in Reparatur",
            hint_add2rental: "Soll dieser Artikel auf eine bereits bestehende Ausleihe gebucht werden? Ist dies der Fall, bitte die gewünschte Ausleihe öffnen und den Artikel darin scannen.",
            inventory: "Bestand",
            firstname: "Vorname",
            lastname: "Nachname",
            email: "E-Mail",
            userIdentifier: "Benutzername",
            password: "Passwort",
            passwordLeaveEmpty: "Leer lassen, um das bestehende Passwort beizubehalten",
            all: "Alle",
            viewAll: "Alle anzeigen",
            addMainCategory: "Hauptkategorie hinzufügen",
            addSubCategory: "Subkategorie hinzufügen",
            createCategoryUnder: 'Kategorie unter "%{name}" erstellen',
            confirmDelete: "Der Datensatz kann nicht wiederhergestellt werden. Fortfahren?",
            state: "Status",
            startDate: "Start",
            endDate: "Ende",
            signature: "Unterschrift",
            signatureDate: "Unterschriftsdatum",
            downloadPdf: "PDF herunterladen",
            downloadCarnet: "Carnet Excel herunterladen",
            downloadEliminationPdf: "Aussonderung PDF herunterladen",
            sendEmail: "Per E-Mail versenden",
            emailSent: "E-Mail wurde versendet",
            lost: "Verlust",
            returned: "Zurückgegeben",
            defect: "Defekt",
            delayed: "Verspätet",
            comment: "Kommentar",
            returnComment: "Kommentar (Rückgabe)",
            lostComment: "Kommentar (Verlust)",
            updateItem: "Eintrag aktualisieren",
            created: "Erstellt",
            size: "Größe",
            media: "Medien",
            arrivalHistory: "Wareneingänge",
            title: "Titel",
            insertLink: "Bitte einen Link einfügen",
            allowedFileTypes: "Erlaubte Dateitypen: PDF, PNG, JPG, JPEG, GIF",
            orderDate: "Bestelldatum",
            orderNumber: "Bestellnummer",
            purchaseOrderNumber: "Auftragsnummer",
            deliveredOk: "Geliefert OK",
            deliveredDefect: "Geliefert Defekt",
            editArrival: "Wareneingang bearbeiten",
            newDelivery: "Neuer Wareneingang",
            save: "Speichern",
            delete: "Löschen",
            close: "Schließen",
            edit: "Bearbeiten",
            viewArrival: "Wareneingänge einsehen",
            arrival: "Wareneingang",
            arrivals: "Wareneingänge",
            mainArrival: "Übergeordneter Wareneingang",
            extractionStatusLabel: "Extraktion",
            extractionStatus: {
                queued: "Wartet",
                processing: "Läuft",
                succeeded: "Fertig",
                failed: "Fehler",
            },
            editSkus: "SKUs bearbeiten",
            editSku: "SKU bearbeiten",
            addSkus: "SKU hinzufügen",
            createSku: "SKU erstellen",
            saveAndContinue: "Speichern & weiter",
            show: "Anzeigen",
            rentedOut: "Verliehen",
            editPrice: "Carnet Preis bearbeiten",
            editName: "Name bearbeiten",
            addTags: "Tags hinzufügen",
            noProductsSelected: "Keine Produkte ausgewählt",
            massProduct: "Mengenartikel",
            individualSkus: "Einzelne SKUs",
            none: "Keine",
            addMedia: "Medien hinzufügen",
            uploadMedia: "Medien hochladen",
            linkToExternalResource: "Link zur externen Ressource",
            addText: "Text hinzufügen",
            showMedia: "Medien anzeigen",
            editMedia: "Medien bearbeiten",
            fullScreen: "Vollbild",
            exitFullScreen: "Vollbild verlassen",
            download: "Herunterladen",
            createProduct: "Produkt erstellen",
            validateDeliveryDate: "Lieferdatum darf nicht vor dem Bestelldatum liegen",
            validateOrderDate: "Bestelldatum darf nicht nach dem Lieferdatum liegen",
            preview: "Vorschau",
            errorLabel: "Fehler",
            error: "Ein unbekannter Fehler ist aufgetreten",
            error_400: "Der Server kann die Anfrage nicht bearbeiten (400)",
            error_404: "Inhalt nicht gefunden (404)",
            error_500: "Serverinterner Fehler (500)",
            error_checksum: "Prüfsumme nicht korrekt",
            error_skuAvailability: "SKU ist nicht verfügbar",
            error_skuAlreadyAdded: "SKU wurde schon hinzugefügt",
            error_failedToFetch: "Bitte überprüfen Sie die Internetverbindung",
            roles: "Rollen",
            permissionsError: "Fehler: unzureichende Berechtigung",
            permissionsErrorDetails: "Unzureichende Berechtigung um die Ressource anzuzeigen oder mit ihr zu interagieren",
            editDescription: "Beschreibung bearbeiten",
            changeLogs: "Änderungsprotokoll",
            rentalLogs: "Ausleihprotokoll",
            from: "Von",
            to: "Bis",
            changed_to: "Zu",
            field: "Feld",
            otherOptions: "Andere Optionen",
            assignEdispoInfo: "eDISPO-Informationen zuweisen",
            assignEdispoManually: "Manuell zuweisen",
            assignEdispoFromRentalSlip: "Aus Leihschein zuordnen",
            edispoId: "eDISPO Id",
            edispoType: "eDISPO Typ",
            edispoIdSiblings: "eDISPO Produkt Verknüpfungen",
            edispoIdAssign: "eDISPO Id zuweisen",
            confirmEdispoAssignment: "%{edispoName} (%{edispoId}) wirklich diesem Element zuordnen?",
            confirmEdispoIdOverwrite: "Das Produkt hat bereits eine eDISPO Id. Überschreiben?",
            unassignEdispoInfoConfirmation: "Zuordnung von eDISPO-Informationen zu diesem Produkt wirklich aufheben?",
            confirmDeleteEdispoItem: "Buchungen wirklich in eDISPO entfernen?",
            resource: "Ressource",
            date: "Datum",
            actions: "Aktionen",
            writeOffYears: "Abschreibungsjahre",
            eliminateSku: "Eine SKU aussondern",
            eliminateProduct: "Ein Produkt aussondern",
            eliminate: "Aussondern",
            sale: "Verkauf",
            scrapping: "Verschrottung",
            loss: "Verlust",
            conversionOfFixedAssets: "Umsetzung von Gegenständen des Anlagevermögens",
            product_info: "Informationen zum Produkt",
            user: "Benutzer",
            tag: "Tag",
            rental: "Ausleihe",
            proceed: "Weiter",
            reason: "Grund",
            eliminationType_sale: "Verkauf",
            eliminationType_scrapping: "Verschrottung",
            eliminationType_loss: "Verlust",
            eliminationType_conversionOfFixedAssets: "Umsetzung von Gegenständen des Anlagevermögens",
            eliminations: "Aussonderungen",
            elimination: "Aussonderung",
            damageReports: "Schadensmeldungen",
            damageReport: "Schadensmeldung",
            damageReportStatus_new: "Neu",
            damageReportStatus_in_progress: "In Bearbeitung",
            damageReportStatus_completed: "Erledigt",
            damageDescription: 'Beschreibung Schaden',
            addDamageReport: "Schadensbericht hinzufügen",
            incidentDescription: 'Beschreibung Vorfall',
            remarks: 'Bemerkungen',
            serialNumber: "Seriennummer",
            print: "Drucken",
            printer: "Drucker",
            printLabels: "Etiketten drucken",
            labelQuantity: "Anzahl der Labels pro Einheit",
            error_empty_supplierId: "Das Feld -Lieferant- darf nicht leer sein",
            error_parent_missing: "Die übergeordnete Kategorie existiert nicht mehr. Bitte die Auswahl aktualisieren.",
            back: "zurück",
            unordered: "Nicht zugeordnet",
            deleteImage: "Bild löschen",
            allowedImageTypes: "Erlaubte Dateitypen: PNG, JPG, JPEG, GIF",
            productImage: "Produktbild",
            categoryToolbar: "Kategorie-Tools",
            labelPrintJobPlaced: "Druckauftrag abgesendet.",
            labelPrintJobNotPlaced: "Druckauftrag konnte nicht abgesendet werden.",
            search: "Suche",
            allOpenRentals: "Alle offenen Ausleihen",
            searchPerson: "Person suchen",
            searchProducts: "Produkte suchen",
            searchRentals: "Ausleihen suchen",
            renter: "Entleiher",
            responsibleUser: "Verantwortlicher Benutzer",
            scan: "Scannen",
            persons: "Personen",
            person: "Person",
            viewSkuList: "SKU-Liste anzeigen",
            available: "verfügbar",
            rent: "Ausleihen",
            of: "von",
            personDetails: "Angaben zur Person",
            skuList: "SKU-Liste",
            article: "Artikel",
            changeStatus: "Status ändern",
            skuActivationAvailabilityHint: "Eine SKU mit Verfügbarkeit „defekt“ oder „verlust“ kann nicht aktiviert werden. Wenn sie wieder vorhanden und einsatzbereit ist, wähle „verfügbar“. Status und Verfügbarkeit werden gemeinsam gespeichert.",
            skuReactivationHint: "Die Verfügbarkeit wird auf „verfügbar“ gesetzt und die SKU wieder aktiviert. Sie kann anschließend wieder ausgeliehen werden. Bitte bestätige nur, wenn die SKU vorhanden und einsatzbereit ist.",
            notAvailable: "n.v.",
            globalSearchLabel: "Label-Nummer / Ausleihnr. / Benutzername",
            userSearchLabel: "Name / PLZ / Stadt / Straße",
            productSearchLabel: "Name / SKU-Nummer / Seriennummer",
            rentalSearchLabel: "Ausleihnr.",
            editRentalDates: "Daten der Ausleihe bearbeiten",
            cancel: "Abbrechen",
            changeTheReturnDate: "Rückgabedatum ändern",
            renterDetails: "Entleiher*in",
            changeRenter: "Entleiher*in wechseln",
            changeComment: "Kommentar ändern",
            confirm: "Bestätigen",
            confirmRenterChange: "Entleiher*in-Wechsel bestätigen",
            rentalItemManagement: "Ausleihe",
            items: "Artikel",
            item: "Artikel",
            openItems: "Offene Artikel",
            addItems: "Artikel hinzufügen",
            return: "Rückgabe",
            printCarnet: "Carnet drucken",
            deleteRental: "Ausleihe löschen",
            rentalDetails: "Ausleihe",
            rentalId: "Ausleihe-Id",
            rentalDate: "Datum der Ausleihe",
            returnDate: "Datum der Rückgabe",
            delayReturnDate: "Verspätung",
            plannedReturnDate: "Ausleihe bis",
            finish: "Abschließen",
            newRental: "Neue Leihe",
            rentalDateExplanation: "Folgende Daten sind voreingestellt und können später für jeden Artikel geändert werden:",
            createRental: "Neue Leihe",
            open: "Offen",
            closed: "Finalisiert",
            noRenter: "Kein Ausleiher",
            rental_inprogress: "Ausleihe in Arbeit",
            clear_rental_process: "Ausleihvorgang leeren",
            return_all_open_items: "Alle offenen Artikel zurückbuchen",
            add_rental_process: "Neuen Ausleihvorgang erstellen",
            remove: "Entfernen",
            removeAll: "Alle entfernen",
            for: "für",
            add: "Hinzufügen",
            add_to_rental: "Leihen",
            deleteRentalItem: "Artikel wirklich löschen?",
            deleteItem: "Artikel wirklich löschen?",
            showDetails: "Details anzeigen",
            hideDetails: "Details ausblenden",
            missing_signature: "Bitte Unterschrift tätigen",
            opened_rental: "Erfolgreich eröffnete Ausleihe",
            home: "Startseite",
            noResultsFound: "Keine Ergebnisse gefunden für \"%{searchString}\"",
            resultsFor: "Ergebnisse für \"%{searchString}\"",
            rentalList: "Liste der Ausleihen",
            return_inprogress: "Rückgabe im Gange",
            partially_returned: "Teilweise zurückgegeben",
            returnManagement: "Rückgabe-Management",
            rentedAmount: "Verliehene Anzahl",
            addSkuLabel: "SKU- / Produktnummer",
            enterQuantity: "Menge eingeben für",
            onlyMine: "Nur eigene",
            removeSwitch: "Zurückbuchen",
            receivable: "Nur offene",
            continueReturn: "Rückgabe fortsetzen",
            rentalItem: "Artikel",
            productDetails: "Einzelheiten zum Produkt",
            reportDelayed: "Verspätung",
            reportLost: "Verlustmeldung",
            delayedUntil: "Aufgeschoben bis",
            author: "Autor",
            comments: "Kommentare",
            addComments: "Kommentare hinzufügen",
            unincludedItemMessage: "Eingegebene Artikelnummer nicht Teil dieser %{contractType}. Bitte wählen:",
            unincludedItemStartContract: "Neue %{contractType} mit diesem Artikel starten",
            unincludedItemGoToContract: "Aktive %{contractType} mit diesem Artikel ansehen",
            unincludedItemListContracts: "Zeige alle aktiven %{contractTypes} mit diesem Artikel",
            unincludedItemGoToItem: "Diesen Artikel ansehen",
            rentalItems_returned: "Keine ausstehenden Artikel mehr vorhanden. Ausleihe abschließen oder noch Änderungen an den Artikeln vornehmen?",
            makeChanges: "Änderungen",
            close_session: "Abschließen",
            close_rental: "Finalisieren",
            close_rental_text: 'Artikel der Ausleihe, die nicht als "zurückgenommen", "verloren" oder "defekt" markiert sind, werden als "verloren" gekennzeichnet. Fortfahren?',
            close_rental_success: "Ausleihe finalisiert",
            sendReceipt: "Leihbeleg an weitere Empfänger*innen schicken",
            downloadReceipt: "Leihbeleg speichern",
            receiptBanner: "Ausleihe erfolgreich eröffnet. Der Leihbeleg wurde an den/die Entleiher*in versandt.",
            additionalRecipients: "Zusätzliche Empfänger*innen",
            send: "Senden",
            addRecipient: "Empfänger*in hinzufügen",
            addVdeCheck: "VDE-Prüfung hinzufügen",
            day: "Tag",
            days: "Tage",
            daysOverdue: "Verzug",
            createRentalOnClosedDay: "Das Startdatum für die Leihe liegt auf einem Schließtag. Fortfahren?",
            outdatedRentalReturnDate: "Ein oder mehrere Artikel der Ausleihe weisen ein Rückgabedatum in der Vergangenheit auf. Bitte ändern bevor die Leihe abgeschlossen wird.",
            signature_text: "Der Ausleih-Gegenstand wurde mir, dem/der Entleiher*in %{firstname} %{lastname}, in einwandfreiem Zustand übergeben. Von der Technik-Leihordnung der Filmakademie Baden-Württemberg habe ich Kenntnis genommen. Ich versichere, dass ich grundsätzlich qualifiziert bin und die geliehene Technik bestimmungsgemäß einsetze. Eine Weitergabe oder Übergabe an Dritte ist nicht möglich.",
            changeReturnDateForAllItems: "Rückgabedatum für alle Artikel ändern",
            addToClipboard: "Zur Zwischenablage hinzufügen",
            removeFromClipboard: "Aus der Zwischenablage entfernen",
            clipboard: "Zwischenablage",
            clearClipboard: "Zwischenablage leeren",
            emptyClipboard: "Die Zwischenablage ist leer.",
            confirmClearClipboard: "Zwischenablage wirklich leeren?",
            onClipboard: "Zur Zwischenablage hinzugefügt",
            action: "Aktion",
            reference: "Referenz",
            productNotfound: "Kein Produkt gefunden",
            skuNotFound: "SKU nicht gefunden",
            rentalsTimeline: "Zeitleiste für Ausleihen",
            rentalsTimeline_noData: "Keine Daten für den angegebenen Zeitraum verfügbar",
            period: "Zeitraum",
            week: "Woche",
            twoWeek: "Zwei Wochen",
            month: "Monat",
            today: "Heute",
            custom: "Benutzerdefiniert",
            compareWithActualData: "mit aktuellen Daten vergleichen",
            timeframeWarning_start_date_after_end_date: "Das Startdatum wird nach dem Enddatum festgelegt",
            timeframeWarning_timeframe_too_wide: "Der gewählte Zeitrahmen erstreckt sich über 60 Tage",
            compareWithOldData: "mit alten Daten vergleichen",
            confirmRemoveItem: "Möchten Sie diesen Artikel wirklich entfernen?",
            changeRentalName: "Name ändern",
            bulkActions: "Massenaktionen",
            createdBy: "Erstellt von",
            create: "Erstellen",
            export: "Exportieren",
            content: "Inhalt",
            forward: "Weiterleiten",
            productCategoryTree: "Produktkategorie Baum",
            active: "Aktiv",
            invitation_pending: "Einladung ausstehend",
            deactivated: "Deaktiviert",
            noEdispoProduct: "Kein eDISPO Produkt",
            fulfilled: "Erfüllt",
            fulfillmentInProgress: "Erfüllung in Arbeit",
            dateDifferences: "Datumsunterschiede",
            scannedTooMany: "Zu viele gescannt",
            missingItem: "Fehlender Artikel",
            notInEdispoList: "Nicht in der eDispo-Liste",
            darkTheme: "Dunkel",
            lightTheme: "Hell",
            confirmRentalMerge: "Möchten Sie folgende Gruppen zusammenführen oder trennen?",
            merge: "Zusammenführen",
            split: "Trennen",
            loading: "Laden",
            endOfResults: "Keine weiteren Ergebnisse",
            rentalItemReturnHistory: "Rückgabeverlauf",
            searchRepairOrders: "Reparaturauftrag suchen",
            repairOrderList: "Reparaturauftragsliste",
            inProgress: "In Arbeit",
            repairOrderStart: "Beginn des Reparaturauftrags",
            repairOrderEnd: "Reparaturauftrag Ende",
            changeRepairOrderName: "Name des Reparaturauftrags ändern",
            changeRepairShop: "Reparaturwerkstatt wechseln",
            noRepairShop: "Keine Reparaturwerkstatt ausgewählt",
            deleteRepairOrder: "Reparaturauftrag löschen",
            repairManagement: "Reparaturauftrag-Management",
            repairOrderDetails: "Details zum Reparaturauftrag",
            repairOrderId: "Reparaturauftrag Id",
            repairReturn: "Reparaturauftrag Rückgabe",
            repair: "Reparatur",
            rentalName: "Name der Ausleihe",
            repairOrderName: "Name des Reparaturauftrags",
            clearRentalProcess: "Ausleihe leeren",
            returnAllOpenItems: "Alle Artikel als zurückgegeben markieren",
            confirmDeleteCarnetRow: "Sind Sie sicher, dass Sie diese Zeile löschen wollen?",
            confirmClearRentalProcess: "Sind Sie sicher, dass Sie die Ausleihe leeren wollen?",
            confirmReturnAllOpenItems: "Sind Sie sicher, dass Sie alle offenen Artikel zurückgeben möchten?",
            repairOrderDate: "Datum des Reparaturauftrags",
            createRepairOrder: "Reparaturauftrag erstellen",
            address: "Adresse Zeile %{addressNumber}",
            addressForm: "Adressformular",
            gender: "Geschlecht",
            male: "Männlich",
            female: "Weiblich",
            country: "Land",
            city: "Stadt",
            zip: "ZIP",
            phone: "Telefon",
            fax: "Fax",
            value: "Wert (€)",
            perItem: "pro Artikel",
            addCarnetItem: "Carnet-Position hinzufügen",
            editCarnetItem: "Carnet-Position bearbeiten",
            total: "Total",
            noOptions: "Keine Ergebnisse",
            editCategory: "Kategorie bearbeiten",
            confirmChangeProductCategory: "Möchten Sie die Kategorie wirklich in %{categoryName} ändern?",
            extract: "Extrahieren",
            chooseFileToExtract: "Datei zum Extrahieren auswählen",
            reExtract: "Erneut extrahieren",
            arrivalInformation: "Wareneingangsinformationen",
            next: "Weiter",
            previous: "Zurück",
            serialNumberRequired: "Seriennummer ist erforderlich",
            addNote: "Notiz hinzufügen",
            filters: "Filter",
            notesOnly: "Nur Notizen",
            extraction: {
                extractionError: "Daten konnten nicht extrahiert werden",
                uploading: "Datei wird hochgeladen...",
                extracting: "Daten werden extrahiert...",
                queued: "Extraktion wartet...",
                processing: "Extraktion läuft...",
                addNewProduct: "Neues Produkt hinzufügen",
                selectedFile: "Ausgewählte Datei: %{fileName}",
            },
            uploadArrival: {
                button: "Wareneingang hochladen",
                title: "Fotos überprüfen",
                capture: "Foto aufnehmen",
                done: "Fertig",
                takePhoto: "Foto aufnehmen",
                fromLibrary: "Aus Galerie",
                reorderHint: "Halten und ziehen, um Reihenfolge zu ändern. Tippen Sie auf das Mülleimer-Symbol zum Löschen.",
                photoCount: "%{count} Foto(s)",
                loadingScanner: "Scanner wird geladen…",
                processingProgress: "Verarbeite %{current}/%{total}…",
                processingError: "Fotos konnten nicht verarbeitet werden",
                uploaded: "Wareneingang erfolgreich hochgeladen",
                arrivalCreateFailed: "Wareneingang konnte nicht angelegt werden",
                mediaUploadFailed: "PDF konnte nicht angehängt werden",
                cameraUnavailable: "Kamera nicht verfügbar. Fotos können über die Galerie hochgeladen werden.",
                cameraInsecure: "Kamera erfordert HTTPS. Bitte über eine sichere Verbindung öffnen oder Fotos aus der Galerie wählen.",
                cameraDenied: "Kamerazugriff verweigert. Berechtigung in den Browser-Einstellungen erlauben oder Fotos aus der Galerie wählen.",
                cameraNotFound: "Keine Kamera gefunden. Bitte Fotos aus der Galerie wählen.",
                crop: "Zuschnitt",
                rotation: "Drehung",
                perspective: "Perspektive",
                vertical: "Vertikal",
                horizontal: "Horizontal",
                rotateLeft: "90° nach links drehen",
                rotateRight: "90° nach rechts drehen",
            },
            dunning: {
                label: "Verzug/Mahnstatus",
                level: 'Mahnstufe',
                level_0: '(ohne)',
                level_1: '1. Mahnung',
                level_2: '2. Mahnung',
                level_3: '3. Mahnung',
                send_level_1: '1. Mahnung schicken',
                send_level_2: '2. Mahnung schicken',
                send_level_3: '3. Mahnung schicken',
                resend_level_3: '3. Mahnung erneut schicken',
                send_dunning_email_text: 'Wollen Sie die Mahnung wirklich verschicken?'
            },
            edispo: {
                id: "eDISPO Id",
                type: "eDISPO Typ",
                in_1a: "IN 1a - Mobile Technik, Aufnahmetechnik",
                in_1b: "IN 1b - Mobiles Tonequipment",
                in_10b: "IN 10b - Animationsinstitut, Hardware",
                renter_check: "Ist die Ausleihende Person %{firstname} %{lastname}?",
                unfinishedEdispoScan: "Artikel des eDISPO-Leihscheins vorhanden, die noch nicht gescannt wurden. Ausleihe ohne diese abschließen?",
                createBookings: "eDISPO-Buchungen anlegen"
            },
            rental_log: {
                rental_inprogress: "Ausleihe erstellt",
                return_inprogress: "Rückkehr im Gange",
                open: "Unterschrieben",
                closed: "Finalisiert",
                returned: "Ausleihe vollständig zurückgegeben",
                reminder_email: "Erinnerungsmail versendet",
                dunning_level_1: "Erste Mahnung versendet",
                dunning_level_2: "Zweite Mahnung versendet",
                dunning_level_3: "Dritte Mahnung versendet",
                dunning_level_3_resent: "Dritte Mahnung erneut versendet",
                dunning_level_3_warning: "Verwarnungs-E-Mail zur dritten Mahnung versendet",
                rental_slip_generation: "Leihschein wurde generiert",
                carnet_generation: "Carnet Datei wurde generiert",
                repair_order_delivery_slip: "Reparatur-Lieferschein wurde generiert",
                delay_report: "Verspätung gemeldet",
                loss_report: "Verlust gemeldet",
                return_item: "Rückgabe",
                add_rental_process: "Neuer Ausleihvorgang erstellt",
                clear_rental_process: "Ausleihvorgang geleert",
                return_all_open_items: "Alle offenen Artikel zurückgebucht",
                cancel_rental_process: "Neuer Ausleihvorgang abgebrochen"
            },
            offline: {
                connectionLost: "Verbindung verloren",
                offlineDetectedDescription: "Die Internetverbindung wurde unterbrochen. Im Offline-Modus können Sie weiterhin Artikel scannen und erfassen. Ihre Daten werden lokal gespeichert und können nach Wiederherstellung der Verbindung übertragen werden.",
                switchToOfflineMode: "Offline-Modus aktivieren",
                switchToOnlineMode: "Online-Modus aktivieren",
                connectionRestored: "Verbindung wiederhergestellt",
                connectionRestoredDescription: "Die Internetverbindung wurde wiederhergestellt. Sie können jetzt in den Online-Modus wechseln, um Ihre Daten zu synchronisieren.",
                offlineStashes: "Offline-Stapel",
                offlineRental: "Offline-Ausleihe",
                offlineRentals: "Offline-Ausleihen",
                offlineReturn: "Offline-Rückgabe",
                offlineReturns: "Offline-Rückgaben",
                noOfflineStashes: "Keine Offline-Stapel vorhanden",
                createOfflineRental: "Offline-Ausleihe erstellen",
                createOfflineReturn: "Offline-Rückgabe erstellen",
                apply: "Anwenden",
                applyAll: "Alle anwenden",
                deleteStash: "Stapel löschen",
                offlineItemAdded: "Offline gespeichert",
                removed: "Entfernt",
            },
        },
        error: {
            product: {
                empty_name: "Das Feld Name muss für alle Sprachen ausgefüllt werden.",
                empty_description: "Das Feld Beschreibung muss für alle Sprachen ausgefüllt werden.",
                empty_category: "Bitte wählen Sie eine Kategorie aus.",
                empty_carnetPrice: "Bitte geben sie ein Carnet Preis an.",
                empty_tags: "Bitte geben Sie mindestens ein Tag an.",
                type_change_has_history: "Der Produkttyp kann nur bei unbenutzten Produkten ohne Ausleihpositionen, Zugänge oder Aussonderungen geändert werden.",
                delete_not_possible: "Ein Löschen des Artikels ist nicht möglich.",
                inspection_intervals_not_allowed: "Prüfintervalle sind für Massenprodukte nicht zulässig.",
            },
            elimination: {
                quantity_change_not_allowed: "Die Menge darf nicht geändert werden.",
                quantity_mismatch: "Aussonderung von mehr Menge als vorhanden nicht möglich.",
                no_mass_product: "Die Produktaussonderung ist nur für Massenprodukte verfügbar. Bitte stattdessen die SKU-Aussonderung verwenden.",
                sku_not_deactivated: "Nur deaktivierte SKU können ausgesondert werden.",
                sku_already_eliminated: "SKU ist bereits ausgesondert.",
            },
            rental: {
                closed_weekday: "An diesem Tag ist die Rückgabe nicht möglich. Bitte einen anderen Wochentag wählen.",
                no_item_found: "Für die angegebene Etikettennummer wurde kein Artikel gefunden.",
                item_already_exists: "Artikel mit SKU existiert bereits.",
                item_already_returned: "Der Artikel wurde bereits zurückgegeben.",
                sku_not_available: "Der gewählte Artikel wird bereits anderweitig verwendet.",
                sku_not_active: "SKU ist nicht aktiv.",
                negative_quantity: "Negative Menge erreicht.",
                quantity_must_be_positive: "Die Menge muss größer als 0 sein.",
                return_quantity_exceeded: "Die Rückgabemenge darf die ausgeliehene Menge nicht überschreiten.",
                invalid_state_transition: "Ungültiger Zustandsübergang.",
                exceeded_max_quantity: "Die Höchstmenge darf nicht überschritten werden.",
                exceeded_max_rentedQuantity: "Der Wert kann die zur Verfügung stehende Menge nicht überschreiten.",
                min_quantity: "Die Menge muss größer als 0 sein.",
                min_quantity_0: "Die Mindestmenge beträgt 0.",
                rental_dates: "Das Rückgabedatum kann nicht vor dem Leihdatum liegen.",
                return_date_closed_day: "Das Rückgabedatum darf nicht auf einem Schließtag liegen.",
                start_date_too_early: 'Die Leihgegenstände können erst am %{startDate} ausgegeben werden.',
                empty_rental: 'Die Ausleihe ist leer.',
                rental_process_not_empty: 'Der Ausleihvorgang ist nicht leer.',
                renter_is_missing: 'Ein/e Ausleiher*in muss angegeben werden.',
                renter_and_name_is_missing: 'Ein Name oder ein/e Ausleiher*in muss angegeben werden.',
            },
            edispo: {
                resource_not_available: "eDISPO-Buchungen verhindern die Ausleihe des Artikels \"%{rentalItem}\" mit Menge %{quantity}. Artikel muss in eDISPO angepasst werden.",
                invalid_dates: "Der gescannte eDISPO-Leihschein ist veraltet (Start- oder Enddaten sind nicht mehr gültig).",
                unavailable_rental_items: "Eine bestehende eDISPO-Reservierung verhindert das Ausleihen folgender Produkte: %{itemName}",
                rental_item_not_found: "Die gewünschte eDISPO Id konnte nicht gefunden werden.",
                create_dispo: "eDISPO-Eintrag kann nicht erzeugt werden.",
                validate_rental: "%{resourceType} / %{resourceId}: %{message}",
                validate_rental_quanitity_exceeded: "%{resourceType} / %{resourceId}: Menge überschritten",
                validate_rental_end_date_exceeded: "%{resourceType} / %{resourceId}: Zeitraum überschritten",
                validate_rental_item_not_found: "%{resourceType} / %{resourceId}: Artikel wurde nicht gebucht",
            },
            printer: {
                unknown: "Unbekannter Drucker.",
                socket_create: "Socket kann nicht erstellt werden.",
            },
            tag: {
                already_exists: "Ein Tag mit diesem Namen existiert bereits.",
            },
            sku: {
                delete_not_possible: "Ein Löschen des Artikels ist nicht möglich.",
            },
            arrival: {
                product_not_found: "Das Produkt konnte nicht gefunden werden.",
                manufacturer_not_found: "Der Hersteller konnte nicht gefunden werden.",
                supplier_missing: "Bitte geben Sie einen Lieferanten an.",
            },
        },
    },
    en: {
        equip: {
            language: "Language",
            language_german: "german",
            language_english: "english",
            name: "Name",
            description: "Description",
            isMassProduct: "is Mass Product",
            isContainer: "is Container",
            quantity: "Quantity",
            openQuantity: "Open Quantity",
            lostQuantity: "Lost",
            defectQuantity: "Defect",
            delayedQuantity: "Delayed",
            status: "Status",
            availability: "Availability",
            inStock: "In Stock",
            actualQuantity: "Available Quantity",
            minimumQuantity: "Minimum Quantity",
            productStockAlerts: "Stock Alerts",
            suggestedOrderQuantity: "Suggested Order Quantity",
            alertDate: "Alert Date",
            firstActualQuantity: "First Available Quantity",
            lowestActualQuantity: "Daily Low",
            lastActualQuantity: "Last Available Quantity",
            isRelevant: "Relevant",
            hasRelevantAlerts: "Open",
            onlyOpenStockAlerts: "Only Open Low Stock",
            daysBelowThreshold: "Days Below Threshold",
            relevantAlertDays: "Open Alert Days",
            highestMissingQuantity: "Highest Missing Quantity",
            currentMissingQuantity: "Current Missing Quantity",
            movementMarkup: "Movement Markup",
            movementMarkupPercentage: "Movement Markup (%)",
            movementMarkupQuantity: "Movement Markup",
            firstAlertDate: "First Alert",
            lastAlertDate: "Last Alert",
            fromAlertDate: "Alerts From",
            toAlertDate: "Alerts To",
            resolvedAt: "Resolved At",
            resolvedByArrival: "Resolved by Arrival",
            rentals: "Rentals",
            overdueRentals: "Overdue Rentals",
            overdue: "Overdue",
            landingPage: "Landing page",
            openLandingPage: "Open landing page",
            maintenance: "Maintenance",
            maintenanceAlarm: "Maintenance alarm",
            maintenanceName: "Maintenance name",
            maintenanceRentalDays: "Maintenance after rental days",
            maintenanceRentalDaysCount: "Counted rental days",
            maintenanceOverdueDays: "Overdue maintenance days",
            maintenanceMessage: "Maintenance message",
            maintenanceCreatedBy: "Maintenance alarm created by",
            maintenanceStartedAt: "Maintenance counter started at",
            maintenanceLastCompletedAt: "Last maintenance completed at",
            completeMaintenance: "Complete maintenance",
            nextMaintenanceRentalDays: "Next maintenance after rental days",
            maintenanceRequired: "Maintenance required",
            maintenanceDone: "Maintenance has been done",
            rentWithoutMaintenance: "Rent out anyway",
            skuInspections: "VDE/UVV inspections",
            inspectionRequired: "Inspection required",
            inspectionType: "Inspection type",
            inspectionResult: "Inspection result",
            recordInspection: "Record inspection",
            nextInspectionDueAt: "Next inspection due date",
            continueWithoutInspection: "Continue without inspection date",
            vdeInspectionIntervalMonths: "VDE inspection interval (months)",
            uvvInspectionIntervalMonths: "UVV inspection interval (months)",
            noInspectionInterval: "Leave empty for no inspection interval",
            lastVdeInspectionAt: "Last VDE inspection",
            lastUvvInspectionAt: "Last UVV inspection",
            skuInspectionType_vde: "VDE",
            skuInspectionType_uvv: "UVV",
            skuInspectionResult_passed: "Passed",
            skuInspectionResult_failed: "Failed",
            yes: "Yes",
            no: "No",
            repairOrder: "Repair Order",
            repairOrders: "Repair Orders",
            category: "Category",
            categories: "Categories",
            manufacturer: "Manufacturer",
            manufacturers: "Manufacturers",
            repairShop: "Repair Shop",
            repairShops: "Repair Shops",
            supplier: "Supplier",
            suppliers: "Suppliers",
            storageLocation: "Storage Location",
            storageLocations: "Storage Locations",
            users: "Users",
            product: "Product",
            products: "Products",
            type: "Type",
            tags: "Tags",
            originCountry: "Origin Country",
            deliveryDate: "Delivery Date",
            purchasePrice: "Purchase Price (EUR)",
            purchasePricePerItem: "Purchase Price per Item (EUR)",
            currentPrice: "Current Price (EUR)",
            carnetPrice: "Carnet Price",
            weight: "Weight (kg)",
            weightPerItem: "Weight per Item (kg)",
            sku: "SKU",
            skuRequired: "SKU required",
            labelNumber: "Label-Number",
            skus: "SKUs",
            sku_status_active: "active",
            sku_status_deactivated: "deactivated",
            sku_status_eliminated: "eliminated",
            sku_availability_available: "available",
            sku_availability_rented_out: "rented out",
            sku_availability_defect: "defect",
            sku_availability_lost: "lost",
            sku_availability_in_repair: "in repair",
            hint_add2rental: "Should this item be added to an existing rental? If this is the case, please open the desired rental and scan the item there.",
            inventory: "Inventory",
            firstname: "Firstname",
            lastname: "Lastname",
            email: "Email",
            userIdentifier: "Username",
            password: "Password",
            passwordLeaveEmpty: "Leave empty to keep the current password",
            all: "All",
            viewAll: "View All",
            addMainCategory: "Add Main Category",
            addSubCategory: "Add Sub Category",
            createCategoryUnder: 'Create Category under "%{name}"',
            confirmDelete: "Data can not be restored. Proceed?",
            state: "State",
            startDate: "Start",
            endDate: "End",
            signature: "Signature",
            signatureDate: "Signature Date",
            downloadPdf: "Download PDF",
            downloadCarnet: "Download Carnet Excel",
            downloadEliminationPdf: "Download Elimination PDF",
            sendEmail: "Send per E-Mail",
            emailSent: "E-Mail sent",
            lost: "Lost",
            returned: "Returned",
            defect: "Defect",
            delayed: "Delayed",
            comment: "Comment",
            returnComment: "Return Commentent",
            lostComment: "Lost Comment",
            updateItem: "Update Item",
            created: "Created",
            size: "Size",
            media: "Media",
            arrivalHistory: "Arrival History",
            title: "Title",
            insertLink: "Please insert a link",
            allowedFileTypes: "Allowed file types: PDF, PNG, JPG, JPEG, GIF",
            orderDate: "Order Date",
            orderNumber: "Order Number",
            purchaseOrderNumber: "Purchase Order Number",
            deliveredOk: "Delivered OK",
            deliveredDefect: "Delivered Defect",
            editArrival: "Edit arrival",
            newDelivery: "New Delivery",
            save: "Save",
            delete: "Delete",
            close: "Close",
            edit: "Edit",
            viewArrival: "View Arrival",
            arrival: "Arrival",
            arrivals: "Arrivals",
            mainArrival: "Main Arrival",
            extractionStatusLabel: "Extraction",
            extractionStatus: {
                queued: "Queued",
                processing: "Running",
                succeeded: "Done",
                failed: "Failed",
            },
            editSkus: "Edit SKUs",
            editSku: "Edit SKU",
            addSkus: "Add SKUs",
            createSku: "Create SKU",
            saveAndContinue: "Save & Continue",
            show: "Show",
            rentedOut: "Rented Out",
            editPrice: "Edit carnet price",
            editName: "Edit name",
            addTags: "Add tags",
            noProductsSelected: "No products were selected",
            none: "None",
            individualSkus: "Individual SKUs",
            massProduct: "Mass Product",
            addMedia: "Add Media",
            uploadMedia: "Upload media",
            linkToExternalResource: "Link to external resource",
            addText: "Add text",
            showMedia: "Show media",
            editMedia: "Edit media",
            fullScreen: "Full Screen",
            exitFullScreen: "Exit Full Screen",
            download: "Download",
            createProduct: "Create product",
            validateDeliveryDate: "Delivery date cannot be ealier than the order date",
            validateOrderDate: "Order date cannot be later than the delivery date",
            preview: "Preview",
            errorLabel: "Error",
            error: "An unknown error has occurred",
            error_400: "Bad Request Error (400)",
            error_404: "Not Found Error (404)",
            error_500: "Internal Server Error (500)",
            error_checksum: "Wrong checksum",
            error_skuAvailability: "SKU is not available",
            error_skuAlreadyAdded: "SKU already added",
            error_failedToFetch: "Please check your internet connection",
            roles: "Roles",
            permissionsError: "Error: insufficient authorization",
            permissionsErrorDetails: "Insufficient authorization to view or interact with the resource",
            editDescription: "Edit description",
            changeLogs: "Change logs",
            rentalLogs: "Rental logs",
            from: "From",
            to: "To",
            changed_to: "Changed to",
            field: "Field",
            otherOptions: "Other options",
            assignEdispoInfo: "Assign eDISPO information",
            assignEdispoManually: "Assign manually",
            assignEdispoFromRentalSlip: "Assign from rental slip",
            edispoId: "eDISPO Id",
            edispoType: "eDISPO Type",
            edispoIdSiblings: "eDISPO product links",
            edispoIdAssign: "Assign eDISPO Id",
            confirmEdispoAssignment: "Should %{edispoName} (%{edispoId}) really be assigned to this item?",
            confirmEdispoIdOverwrite: "The product has an eDISPO Id already. Overwrite?",
            unassignEdispoInfoConfirmation: "Do you really want to remove the assignment of eDISPO information to this item?",
            confirmDeleteEdispoItem: "Do you really want to delete this item in eDISPO?",
            resource: "Resource",
            date: "Date",
            actions: "Actions",
            writeOffYears: "Write-off Years",
            eliminateSku: "Eliminate a SKU",
            eliminateProduct: "Eliminate a Product",
            eliminate: "Eliminate",
            sale: "Sale",
            scrapping: "Scrapping",
            loss: "Loss",
            conversionOfFixedAssets: "Conversion of fixed assets",
            product_info: "Product information",
            user: "User",
            tag: "Tag",
            rental: "Rental",
            proceed: "Proceed",
            reason: "Reason",
            eliminationType_sale: "Sale",
            eliminationType_scrapping: "Scrapping",
            eliminationType_loss: "Loss",
            eliminationType_conversionOfFixedAssets: "Conversion of fixed assets",
            elimination: "Elimination",
            eliminations: "Eliminations",
            damageReports: "Damage reports",
            damageReport: "Damage report",
            damageReportStatus_new: "New",
            damageReportStatus_in_progress: "In progress",
            damageReportStatus_completed: "Completed",
            damageDescription: 'Damage description',
            addDamageReport: "Add damage report",
            incidentDescription: 'Incident description',
            remarks: 'Remarks',
            serialNumber: "Serial Number",
            printLabels: "Print labels",
            print: "Print",
            printer: "Printer",
            labelQuantity: "Number of labels per item",
            error_empty_supplierId: "Supplier field cannot be empty",
            error_parent_missing: "The parent category no longer exists. Please refresh the selection.",
            back: "Back",
            unordered: "Unordered",
            deleteImage: "Delete Image",
            allowedImageTypes: "Allowed file types: PNG, JPG, JPEG, GIF",
            productImage: "Product image",
            categoryToolbar: "Category Toolbar",
            labelPrintJobPlaced: "Print job sent.",
            labelPrintJobNotPlaced: "Print job could not be sent.",
            search: "Search",
            allOpenRentals: "All Open Rentals",
            searchPerson: "Search Person",
            searchProducts: "Search Products",
            searchRentals: "Search Rentals",
            renter: "Renter",
            responsibleUser: "Responsible User",
            scan: "Scan",
            persons: "Persons",
            person: "Person",
            viewSkuList: "View SKU List",
            available: "available",
            rent: "rent",
            of: "of",
            personDetails: "Person details",
            skuList: "SKU List",
            article: "Article",
            changeStatus: "Change status",
            skuActivationAvailabilityHint: "A SKU marked as defective or lost cannot be activated. If it is present and ready for use again, select available. Status and availability will be saved together.",
            skuReactivationHint: "The availability will be set to available and the SKU will be reactivated. It can then be rented out again. Only confirm if the SKU is present and ready for use.",
            notAvailable: "N/A",
            globalSearchLabel: "Label-Number / Rental-Id / Username",
            userSearchLabel: "Name / ZIP / City / Street",
            productSearchLabel: "Name / SKU number / Serial number",
            rentalSearchLabel: "Rental-Id",
            editRentalDates: "Edit rental dates",
            cancel: "Cancel",
            changeTheReturnDate: "Change return date",
            renterDetails: "Renter details",
            changeRenter: "Change renter",
            changeComment: "Change comment",
            confirm: "Confirm",
            confirmRenterChange: "Confirm renter change",
            rentalItemManagement: "Rental item management",
            items: "Items",
            item: "Item",
            openItems: "Open Items",
            addItems: "Add items",
            return: "Return",
            printCarnet: "Print carnet",
            deleteRental: "Delete rental",
            rentalDetails: "Rental details",
            rentalId: "Rental-Id",
            rentalDate: "Rental date",
            returnDate: "Return date",
            delayReturnDate: "Delay",
            plannedReturnDate: "Planned return date",
            finish: "Finish",
            newRental: "New rental",
            rentalDateExplanation: "The following dates are presets and can be changed later for every item:",
            createRental: "Create rental",
            open: "Open",
            closed: "Finalized",
            noRenter: "No renter",
            rental_inprogress: "Rental in progress",
            add_rental_process: "Add rental process",
            clear_rental_process: "Clear rental process",
            return_all_open_items: "Return all open items",
            remove: "Remove",
            removeAll: "Remove all",
            for: "for",
            add: "Add",
            add_to_rental: "Add",
            deleteRentalItem: "Really delete this rental item?",
            deleteItem: "Really delete this item?",
            showDetails: "Show details",
            hideDetails: "Hide details",
            missing_signature: "Please add a signature",
            opened_rental: "Successfully opened Rental",
            home: "Home",
            noResultsFound: "No results for \"%{searchString}\"",
            resultsFor: "Results for \"%{searchString}\"",
            rentalList: "Rental list",
            return_inprogress: "Return in progress",
            partially_returned: "Partially returned",
            returnManagement: "Return management",
            rentedAmount: "Rented amount",
            addSkuLabel: "SKU / Product number",
            enterQuantity: "Enter quantity for",
            onlyMine: "Only mine",
            removeSwitch: "Remove items",
            receivable: "Receivable",
            continueReturn: "Continue return",
            rentalItem: "Rental item",
            productDetails: "Product details",
            reportDelayed: "Report delayed",
            reportLost: "Report lost",
            delayedUntil: "Delayed until",
            author: "Author",
            comments: "Comments",
            addComments: "Add comments",
            unincludedItemMessage: "Entered label number is not part of this %{contractType}. Please select:",
            unincludedItemStartContract: "Start a new %{contractType} with this article",
            unincludedItemGoToContract: "Go to the %{contractType} with this article",
            unincludedItemListContracts: "List all active %{contractTypes} with this article",
            unincludedItemGoToItem: "View this article",
            rentalItems_returned: "No articles remaining to be returned for this rental. Close the return session now or still make changes to the articles?",
            makeChanges: "Make changes",
            close_session: "Close session",
            close_rental: "Finalize",
            close_rental_text: 'Items of this rental that are not set to "returned", "lost" or "defective" will be marked as “lost”. Continue?',
            close_rental_success: "Rental finalized",
            sendReceipt: "Send rental receipt to additional recipients",
            downloadReceipt: "Download rental receipt",
            receiptBanner: "Rental opened successfully. The receipt has been sent to the renter.",
            additionalRecipients: "Additional recipients",
            send: "Send",
            addRecipient: "Add a recipient",
            addVdeCheck: "Add VDE Check",
            day: "day",
            days: "days",
            daysOverdue: "Delay",
            createRentalOnClosedDay: "Rental start date is on a closing day. Proceed?",
            outdatedRentalReturnDate: "One or more of the rental items have a return date in the past. Please change this before finishing this rental.",
            signature_text: 'The rental items were handed over to me, renter %{firstname} %{lastname}, in perfect condition. I have taken note of the rental agreement of the Filmakademie Baden-Württemberg. I assure that I am fundamentally qualified and will use the rented items as intended. A forwarding or transfer to third parties is not possible.',
            changeReturnDateForAllItems: "Change return date for all items",
            addToClipboard: "Add to clipboard",
            removeFromClipboard: "Remove from clipboard",
            clipboard: "Clipboard",
            clearClipboard: "Clear clipboard",
            emptyClipboard: "The clipboard is empty.",
            confirmClearClipboard: "Really clear the clipboard?",
            onClipboard: "Added to clipboard",
            action: "Action",
            reference: "Reference",
            productNotfound: "No product was found",
            skuNotFound: "SKU not found",
            rentalsTimeline: "Rentals timeline",
            rentalsTimeline_noData: "No data available for the give period",
            period: "Period",
            week: "Week",
            twoWeek: "Two week",
            month: "Month",
            today: "Today",
            custom: "Custom",
            compareWithActualData: "Compare with actual data",
            timeframeWarning: "Time frame warning",
            timeframeWarning_start_date_after_end_date: "The start date is set after the end date",
            timeframeWarning_timeframe_too_wide: "The selected timeframe spans over 60 days",
            compareWithOldData: "Compare with old data",
            confirmRemoveItem: "Do you really want to remove this item?",
            changeRentalName: "Change rental name",
            bulkActions: "Bulk actions",
            createdBy: "Created by",
            create: "Create",
            export: "Export",
            content: "Content",
            forward: "Forward",
            productCategoryTree: "Product category tree",
            active: "Active",
            invitation_pending: "Invitation pending",
            deactivated: "Deactivated",
            noEdispoAssigned: "No eDISPO product",
            fulfilled: "Fulfilled",
            fulfillmentInProgress: "Fulfillment in progress",
            dateDifferences: "Date differences",
            scannedTooMany: "Scanned too many",
            missingItem: "Missing item",
            notInEdispoList: "Not in eDispo list",
            darkTheme: "Dark theme",
            lightTheme: "Light theme",
            confirmRentalMerge: "Do you want to merge or split these groups?",
            merge: "Merge",
            split: "Split",
            loading: "Loading",
            endOfResults: "End of results",
            rentalItemReturnHistory: "Rental item return history",
            searchRepairOrders: "Search repair orders",
            repairOrderList: "Repair order list",
            inProgress: "In progress",
            repairOrderStart: "Repair order start",
            repairOrderEnd: "Repair order end",
            changeRepairOrderName: "Change repair order name",
            changeRepairShop: "Change repair shop",
            noRepairShop: "No repair shop selected",
            deleteRepairOrder: "Delete repair order",
            repairManagement: "Repair order management",
            repairOrderDetails: "Repair order details",
            repairOrderId: "Repair order Id",
            repairReturn: "Repair order return",
            repair: "Repair",
            rentalName: "Rental name",
            repairOrderName: "Repair order name",
            clearRentalProcess: "Clear rental process",
            returnAllOpenItems: "Return all open items",
            confirmDeleteCarnetRow: "Are you sure you want to delete this row?",
            confirmClearRentalProcess: "Are you sure you want to clear the rental process?",
            confirmReturnAllOpenItems: "Are you sure you want to return all open items?",
            repairOrderDate: "Repair order date",
            createRepairOrder: "Create repair order",
            address: "Address Line %{addressNumber}",
            addressForm: "Address form",
            gender: "Gender",
            male: "Male",
            female: "Female",
            country: "Country",
            city: "City",
            zip: "ZIP",
            phone: "Phone",
            fax: "Fax",
            value: "Value (€)",
            perItem: "per item",
            addCarnetItem: "Add carnet item",
            editCarnetItem: "Edit carnet item",
            total: "Total",
            noOptions: "No options",
            editCategory: "Edit category",
            confirmChangeProductCategory: "Do you really want to change the category to %{categoryName}?",
            extract: "Extract",
            chooseFileToExtract: "Choose file to extract",
            reExtract: "Re-extract",
            arrivalInformation: "Arrival information",
            next: "Next",
            previous: "Previous",
            serialNumberRequired: "Serial number is required",
            addNote: "Add note",
            filters: "Filters",
            notesOnly: "Notes only",
            extraction: {
                extractionError: "Failed to extract data",
                uploading: "Uploading file...",
                extracting: "Extracting data...",
                queued: "Extraction queued...",
                processing: "Extraction running...",
                addNewProduct: "Add new product",
                selectedFile: "Selected file: %{fileName}",
            },
            uploadArrival: {
                button: "Upload arrival",
                title: "Review photos",
                capture: "Capture photo",
                done: "Done",
                takePhoto: "Take photo",
                fromLibrary: "From library",
                reorderHint: "Press and hold to drag and reorder. Tap the trash icon to delete.",
                photoCount: "%{count} photo(s)",
                loadingScanner: "Loading scanner…",
                processingProgress: "Processing %{current}/%{total}…",
                processingError: "Failed to process photos",
                uploaded: "Arrival uploaded successfully",
                arrivalCreateFailed: "Failed to create arrival",
                mediaUploadFailed: "Failed to attach PDF to arrival",
                cameraUnavailable: "Camera not available. You can upload photos from your library.",
                cameraInsecure: "Camera requires HTTPS. Open this page over a secure connection, or pick photos from your library.",
                cameraDenied: "Camera permission was denied. Allow it in your browser settings, or pick photos from your library.",
                cameraNotFound: "No camera was found on this device. Please pick photos from your library.",
                crop: "Crop",
                rotation: "Rotation",
                perspective: "Perspective",
                vertical: "Vertical",
                horizontal: "Horizontal",
                rotateLeft: "Rotate 90° left",
                rotateRight: "Rotate 90° right",
            },
            dunning: {
                label: "Delay/Dunning status",
                level: 'Dunning Level',
                level_0: '(none)',
                level_1: '1. Reminder',
                level_2: '2. Reminder',
                level_3: '3. Reminder',
                send_level_1: 'Send 1. Reminder',
                send_level_2: 'Send 2. Reminder',
                send_level_3: 'Send 3. Reminder',
                resend_level_3: 'Resend 3. Reminder',
                send_dunning_email_text: 'Do you really want to send the reminder?'
            },
            edispo: {
                id: "eDISPO Id",
                type: "eDISPO Type",
                in_1a: "IN 1a - Camera",
                in_1b: "IN 1b - Sound",
                in_10b: "IN 10b - Hardware",
                renter_check: "Is the renter %{firstname} %{lastname}?",
                unfinishedEdispoScan: "There are still open items on the eDISPO rental slip that have not been added yet. Finish the rental without them?",
                createBookings: "Create eDISPO-Bookings"
            },
            rental_log: {
                rental_inprogress: "Rental generated",
                return_inprogress: "Items returned",
                open: "Rental signed",
                closed: "Return finalized",
                returned: "Rental fully returned",
                reminder_email: "Reminder E-Mail sent",
                dunning_level_1: "1st Dunning Letter sent",
                dunning_level_2: "2nd Dunning Letter sent",
                dunning_level_3: "3rd Dunning Letter sent",
                dunning_level_3_resent: "3rd Dunning Letter resent",
                dunning_level_3_warning: "3rd Dunning warning sent",
                rental_slip_generation: "Rental slip generated",
                carnet_generation: "Carnet generated",
                repair_order_delivery_slip: "Repair order delivery slip generated",
                delay_report: "Late return created",
                loss_report: "Marked as lost",
                return_item: "Return",
                add_rental_process: "Added rental process",
                clear_rental_process: "Cleared rental process",
                return_all_open_items: "All open items returned",
                cancel_rental_process: "Canceled new rental process"
            },
            offline: {
                connectionLost: "Connection Lost",
                offlineDetectedDescription: "The internet connection has been lost. In offline mode you can continue scanning and recording items. Your data will be saved locally and can be applied once the connection is restored.",
                switchToOfflineMode: "Switch to offline mode",
                switchToOnlineMode: "Switch to online mode",
                connectionRestored: "Connection Restored",
                connectionRestoredDescription: "The internet connection has been restored. You can now switch to online mode to sync your data.",
                offlineStashes: "Offline Stashes",
                offlineRental: "Offline Rental",
                offlineRentals: "Offline Rentals",
                offlineReturn: "Offline Return",
                offlineReturns: "Offline Returns",
                noOfflineStashes: "No offline stashes available",
                createOfflineRental: "Create Offline Rental",
                createOfflineReturn: "Create Offline Return",
                apply: "Apply",
                applyAll: "Apply All",
                deleteStash: "Delete Stash",
                offlineItemAdded: "Saved Offline",
                removed: "Removed",
            },
        },
        error: {
            product: {
                empty_name: "Name field must be filled for all locales.",
                empty_description: "Description field must be filled for all locales.",
                empty_category: "Please select a category.",
                empty_carnetPrice: "Please enter a valid carnet price.",
                empty_tags: "Please add at least one tag.",
                type_change_has_history: "The product type can only be changed for unused products without rental items, arrivals or eliminations.",
                delete_not_possible: "It is not possible to delete this item.",
                inspection_intervals_not_allowed: "Inspection intervals are not allowed for mass products.",
            },
            elimination: {
                quantity_change_not_allowed: "Quantity may not be changed.",
                quantity_mismatch: "Elimination of more quantity than in existence not possible.",
                no_mass_product: "Product Elimination only available for Mass Products. Use SKU elimination instead.",
                sku_not_deactivated: "Only deactivated SKU can be eliminated.",
                sku_already_eliminated: "SKU is already eliminated.",
            },
            rental: {
                closed_weekday: "Returns are not possible on this day. Please select a different day of the week.",
                no_item_found: "No item found for given label number.",
                item_already_exists: "Item with sku already exists.",
                item_already_returned: "Item is already returned.",
                sku_not_available: "The selected item is already being used elsewhere.",
                sku_not_active: "SKU is not active.",
                negative_quantity: "Negative quantity reached.",
                quantity_must_be_positive: "The quantity must be greater than 0.",
                return_quantity_exceeded: "The returned quantity cannot exceed the rented quantity.",
                invalid_state_transition: "Invalid state transition.",
                exceeded_max_quantity: "Cannot exceed maximum quantity.",
                exceeded_max_rentedQuantity: "The value cannot exceed rented quantity.",
                min_quantity: "Quantity must be greater than 0.",
                min_quantity_0: "Minimum quantity is 0.",
                rental_dates: "Return date cannot be earlier than rental date.",
                return_date_closed_day: "Return date cannot be on a closing day.",
                start_date_too_early: 'The rental items cannot be issued until %{startDate}.',
                empty_rental: 'The rental is empty.',
                rental_process_not_empty: 'The rental process is not empty.',
                renter_is_missing: 'The renter is missing.',
                renter_and_name_is_missing: 'A name or a renter is needed.',
            },
            edispo: {
                resource_not_available: "eDISPO reservations prevent the rental of this product \"%{rentalItem}\" with quantity %{quantity}. The item must be updated in eDISPO.",
                invalid_dates: "The eDISPO rental slip you have scanned is outdated (either start date or end date is not valid any longer).",
                unavailable_rental_items: "An existing eDISPO reservation prevents the rental of following products: %{itemName}",
                rental_item_not_found: "The requested eDISPO Id could not be found.",
                create_dispo: "Cannot create eDISPO entry.",
                validate_rental: "%{resourceType} / %{resourceId}: %{message}",
                validate_rental_quanitity_exceeded: "%{resourceType} / %{resourceId}: Quantity exceeded",
                validate_rental_end_date_exceeded: "%{resourceType} / %{resourceId}: Timeframe exceeded",
                validate_rental_item_not_found: "%{resourceType} / %{resourceId}: Article not booked",
            },
            printer: {
                unknown: "Unknown printer.",
                socket_create: "Cannot create socket.",
            },
            tag: {
                already_exists: "A tag with this name already exists.",
            },
            sku: {
                delete_not_possible: "It is not possible to delete this item.",
            },
            arrival: {
                product_not_found: "The product cannot be found.",
                manufacturer_not_found: "The manufacturer cannot be found.",
                supplier_missing: "Please select a supplier.",
            },
        },
    },
};

export const { de, en } = messages;
